export { default as globalStore } from "./globalStore";
export { default as docStore } from "./docStore";
